import { store } from '../index'
import { onError } from 'utils/helpers'
import { requestConfig } from '../../utils/httpClient'

/**
 * @param {Object} data
 */
function fetchTokens(data) {
  return async dispatch => {
    dispatch({ type: 'CONTENT_LOADING', isLoading: true })

    function onSuccess(response) {
      const { status_id, detail } = response.data
      if (status_id !== 200) {
        throw response
      }

      dispatch({
        type: 'TOKEN_INFO',
        tokens: detail.tokens,
      })
      dispatch({
        type: 'USER_AUTH',
        isAuth: true,
      })
    }

    try {
      const response = await requestConfig.post(
        '/api/v1/auth/token-auth/',
        data
      )

      return onSuccess(response)
    } catch (error) {
      throw onError(error)
    } finally {
      dispatch({ type: 'CONTENT_LOADING', isLoading: false })
    }
  }
}

function refreshTokens() {
  return async dispatch => {
    try {
      const { refresh } = store.getState().tokenInfo
      const response = await requestConfig.post(
        '/api/v1/auth/token-refresh/',
        { token: refresh }
      )

      dispatch({
        type: 'TOKEN_INFO',
        tokens: response.data.detail,
      })
    } catch (error) {
      throw error
    }
  }
}

export default {
  fetchTokens,
  refreshTokens,
}
